// A route pack: a route prefix on a site that serves an uploaded, unzipped
// static bundle instead of a composed page.
//
// This is the gen-2 `site-pack` entity (archive/recovered/stack-pkg/src/data/
// site-pack), ported. It is the escape hatch for putting a build the CMS did
// not author — a React app, a docs site, a legacy static tree — on a path of a
// site the CMS otherwise owns. A page is composed out of elements; a pack is
// bytes somebody uploaded, and the renderer never sees it.
//
// WHAT IS DELIBERATELY NOT HERE
//
// Gen-2 kept a denormalized `mountpoints` array on the SITE row and rewrote it
// on every pack mutation (`site.mount()` / `site.unmount()`). That is not
// ported. The site row is also what the one-Save Configuration screen writes,
// and mount/unmount is a read-modify-write over an array, so two concurrent
// pack edits — or a pack edit racing a config save — silently drop entries.
// Resolution reads this table's partition instead.
import { properties } from "@repoflow/common/schema-fields";
import { siteKey } from "@common/schema/site/key";

const { createdAt, updatedAt } = properties;

export { createdAt, updatedAt };

// The partition: `${orgId}/${siteId}`. See @common/schema/site/key.
export { siteKey };

export const orgId = {
  type: "string",
};

export const siteId = {
  type: "string",
};

// Chosen by the caller, not minted — a pack is referred to by name on the
// screen that mounts it ("docs", "app"), and a uuid would make the list
// unreadable. Same argument as `sectionId`, and the same consequence: the
// model opts into `createIfNotExists`, because with a caller-chosen key a
// plain put is a blind overwrite of somebody else's pack.
export const packId = {
  label: "Name",
  $ref: "/Name/Required",
  minLength: 1,
  default: "",
};

// The prefix this pack answers on. Everything at or below it is served from
// the bundle.
//
// NOT `/Route` from @repoflow/schema/utils, and not `/Page/Route` either.
// `/Route` carries no `minLength`, and `/Page/Route` additionally admits the
// empty string — which it must, because pages written before that field
// existed have no route. Neither is right here: there are no legacy pack rows
// to admit, and a pack mounted at "" is a pack mounted at nothing. So this is
// a local document, declared in the default export below, exactly the way
// @common/schema/page/fields declares /Page/Route.
export const route = {
  label: "Route",
  $ref: "/SitePack/Route",
  default: "/",
};

// How a request under the mount is turned into a path in the bundle. The two
// modes differ ONLY in what a directory URL resolves to:
//
//   zip  a static tree — `/docs/guide/` serves `guide/index.html`
//   spa  a client-routed app — `/app/anything/` serves the bundle's OWN
//        index.html and lets the app's router take over
//
// Anything not ending in a slash is the literal file in both modes. Gen-2 made
// this immutable after create; it is not immutable here — flipping the mode of
// an already-uploaded bundle is a legitimate correction, and forcing a
// delete-and-recreate to do it only loses the route.
export const type = {
  label: "Type",
  type: "string",
  default: "spa",
  enum: ["spa", "zip"],
};

// The site file holding the archive — a row in `site-files-table` under this
// site's `documents` kind. Only `documents` accepts `zip`
// (@common/schema/site-file/kind), so the kind is implied and is not stored.
//
// Empty until somebody picks one, and that is a real state rather than a
// half-written row: a pack is named and routed on the create screen, and the
// bundle is attached afterwards. `status` below is what says so.
export const fileId = {
  label: "Archive",
  type: "string",
  // A read-only box and a picker — see app/code/src/widgets/archive. Registered
  // in that app's widget table, which `register.test.js` asserts against every
  // `widget:` any public schema names.
  widget: "archive",
  default: "",
};

// `pending` until a file is attached, `active` once one is. Gen-2 wrote
// "active" at create and never read the field again, which is why its list
// screen showed a pack with no bundle as though it were live and its route
// answered 404. This one is read — by the resolver, which skips a pack that is
// not active, and by the list screen, which says so.
export const status = {
  type: "string",
};

// Extra documents these fields reference. Spread by data.js and public.js the
// same way UtilsSchema is.
export default [
  {
    id: "/SitePack/Route",
    type: "string",
    maxLength: 256,
    minLength: 1,
    pattern: "^/[/.:a-zA-Z0-9-]*$",
  },
];
